<dialog
  #dialog
  class="download-sheet"
  aria-labelledby="download-app-title"
  aria-describedby="download-app-description"
  (click)="onBackdropClick($event)"
  (close)="restoreBodyScroll()">
  <div class="sheet-content">
    <div class="sheet-handle" aria-hidden="true"></div>
    <button
      type="button"
      class="close-button"
      autofocus
      [attr.aria-label]="i18n.t('shell.close')"
      (click)="close()">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="m6 6 12 12M18 6 6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
      </svg>
    </button>

    <div class="app-icon" aria-hidden="true">
      <img src="/static_images/ic_logo.svg" alt="" width="52" height="52" />
    </div>
    <h2 id="download-app-title">{{ i18n.t('shell.downloadAppTitle') }}</h2>
    <p id="download-app-description">{{ i18n.t('shell.downloadAppDescription') }}</p>

    <div class="store-links">
      @if (platform !== 'android') {
        <a
          href="https://apps.apple.com/us/app/realty-buy-rent/id6769394118"
          class="store-link"
          target="_blank"
          rel="noopener noreferrer">
          <img class="apple-icon" src="/static_images/apple_logo.svg" alt="" width="28" height="30" />
          <span class="store-label">
            <span class="store-caption">{{ i18n.t('shell.downloadOn') }}</span>
            <span class="store-name">App Store</span>
          </span>
        </a>
      }
      @if (platform !== 'ios') {
        <a
          href="https://play.google.com/store/apps/details?id=one.realty.app"
          class="store-link"
          target="_blank"
          rel="noopener noreferrer">
          <svg class="play-icon" width="28" height="30" viewBox="0 0 28 28" aria-hidden="true">
            <path d="M13.755,84.779a1.973,1.973,0,0,0-.478,1.415V108.44a1.973,1.973,0,0,0,.478,1.415l.075.068L26.6,97.461v-.294L13.829,84.706Z" transform="translate(-13.276 -84.102)" fill="#5ed2fa" />
            <path d="M34.743,104.045l-4.251-4.156V99.6l4.257-4.156.1.054,5.041,2.8c1.439.795,1.439,2.1,0,2.9l-5.041,2.8Z" transform="translate(-17.17 -86.529)" fill="#f8cf47" />
            <path d="M31.089,105.249,26.737,101,13.894,113.54a1.709,1.709,0,0,0,2.143.059Z" transform="translate(-13.416 -87.787)" fill="#ea4c4b" />
            <path d="M31.089,92.97,16.037,84.619a1.715,1.715,0,0,0-2.143.064L26.737,97.219Z" transform="translate(-13.416 -84.006)" fill="#6deb83" />
          </svg>
          <span class="store-label">
            <span class="store-caption">{{ i18n.t('shell.getItOn') }}</span>
            <span class="store-name">Google Play</span>
          </span>
        </a>
      }
    </div>
  </div>
</dialog>
